<template>
  <div class="withdraw">
    <div class="wrapper">
      <Header title="提币" :show-back="true" color="white" />
      <div class="pancel">
        <van-cell
          is-link
          class="select-item"
          title="选择币种类型"
          title-class="select-item-title"
          value-class="select-item-value"
          :value="coin"
        />
        <van-cell
          class="currency"
          :title="`${coin}余额`"
          title-class="value-text"
          value-class="currency-value"
          :value="balance"
        />
      </div>
    </div>
    <div class="content">
      <div class="cell">
        <dl class="cell-title">提现数量</dl>
        <dl class="cell-value">
          <input class="numInput" v-model="num" placeholder="请输入"/>
          <span> {{coin}}</span>
          <!-- <span class="num">0.24758  </span> -->
        </dl>
      </div>
      <div class="result">
        <dl>
          <span class="label">可提数量：</span>
          <span class="value-text">{{balance}}</span>{{coin}}
        </dl>
        <dl class="result-all" @click="selectAll">全部</dl>
      </div>
      <div class="cell-title">钱包地址</div>
      <div class="cell-input">
        <input placeholder="请输入钱包地址" v-model="address" style="width: 100%;"/>
      </div>

      <div class="cell-wrap">
        <div class="cell">
          <dl class="cell-desc">手续费</dl>
          <dl class="cell-value">
            <span class="num">{{fee}}</span>{{coin}}
          </dl>
        </div>
        <div class="cell">
          <dl class="cell-desc">实际到账</dl>
          <dl class="cell-value">
            <span class="num">{{this.getRecive()}}</span>{{coin}}
          </dl>
        </div>
      </div>

      <div class="cell-title">交易密码</div>
      <div class="cell-input">
        <input placeholder="请输入交易密码" v-model="paypassword"/>
      </div>
      <button class="form-item-btn" @click="widtdraw">立即提币</button>
    </div>
  </div>
</template>

<script>
import Header from "../../components/header";
export default {
  components: {
    Header
  },
  data() {
    return {
      num:'',
      coin: "USDT",
      fee:'',
      balance:'',
      address:'',
      paypassword:''
    };
  },
  created(){
    this.getWithdraw()
  },
  methods:{
    getWithdraw(){
      this.ajax.post('appapi/user/withdrawInfo',{coin:this.coin}).then((res)=>{
        if(res.data.code===1){
          this.balance = res.data.data.balance
           this.fee = res.data.data.fee
        }
      })
    },
    getRecive(){
      return this.num-this.fee
    },
    selectAll(){
      this.num = this.balance
    },
    widtdraw(){
      if (parseInt(this.num)>parseInt(this.balance)) {
          this.$toast("提现金额不能大余额");
          return
      }
       if (!this.paypassword) {
          this.$toast("请输入交易密码");
          return
      }
      let data = {
        num:this.num,
        coin:this.coin.toLowerCase(),
        paypassword:this.paypassword,
        address:this.address
      }
      this.ajax.post('appapi/user/addCointowithdraw',data).then((res)=>{
        if(res.data.code===1){
          this.$toast(res.data.msg || '提币成功')
          this.getWithdraw()
        }
      })
    }
  }
};
</script>

<style lang="scss">
.value-text {
  color: #333;
  font-size: 26px;
  font-weight: bold;
}
.withdraw {
  background: #fefefe;
  .wrapper {
    background: url(../../assets/img/background2.png) no-repeat 0 0;
    background-size: 100%;
    width: 100%;
    padding: 60px 0 0;
  }
  .pancel {
    margin: 40px 40px 40px;
    padding: 27px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 10px 29px 0px rgba(226, 226, 226, 0.4);
    border-radius: 10px;
  }
  .select-item {
    background: #f8f8f8;
    border-radius: 10px;
    &-title {
      color: #c0c5d0;
      font-size: 26px;
    }
    &-value {
      font-size: 28px;
      color: #333;
      font-weight: bold;
    }
  }
  .currency {
    background: #f8f8f8;
    border-radius: 10px;
    margin-top: 27px;
    &-value {
      color: #0ec15e;
      font-weight: bold;
    }
  }
  .content {
    padding: 10px 40px 80px;
    .cell {
      background-color: #fff;
      padding-right:24px;
      @include flex($main: space-between);
      font-size: 28px;

      &-title {
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 20px;
        padding-left:8px;
      }
      &-value {
        color: #7b8292;
        .num,.numInput {
          font-weight: bold;
          color: #333;
         
        }
        .numInput{
           text-align: right;
          margin-right:10px;
        }
      }
      &-desc {
        font-size: 26px;
        color: #6f788b;
        margin-bottom:28px;
      }
      &-input {
        height: 86px;
        line-height: 86px;
        background: rgba(248, 248, 248, 1);
        border-radius: 10px;
        color: #c0c5d0;
        font-size: 26px;
        margin-bottom: 50px;
        padding-left: 25px;
      }
      &-wrap{
        padding:25px 0 0 27px;
        background:rgba(255,255,255,1);
        box-shadow:0px 10px 29px 0px rgba(226,226,226,0.4);
        border-radius:10px;
        margin-bottom:59px;
      }
    }
    .result {
      @include flex($main: space-between);
      font-size: 26px;
      color: #c0c5d0;
      padding: 15px 24px 60px 8px;
      .label {
        color: #8d929c;
      }
      &-all {
        color: #1fc26d;
        font-size: 28px;
      }
    }
  }
  .form-item-btn{
    margin-top:32px;
  }
}
</style>